import { ReactNode } from 'react';
import cn from 'classnames';
import staticUrls from '@framework/url/staticUrls';
import termsOfUseStyles from './termsOfUse.module.scss';

interface IProps {
  className?: string,
  children?: ReactNode,
}

const TermsOfUse = ({
  className,
  children = (
    <>
      By continuing, you agree to FINSIGHT's <br />
      <a href={ staticUrls.getTermsOfUseUrl() } target="_blank">
        Terms of Use
      </a>{ ' ' }
      and{ ' ' }
      <a href={ staticUrls.getPrivacyPolicyUrl() } target="_blank">
        Privacy Policy
      </a>
    </>
  ),
}: IProps) => {
  return <div className={ cn(termsOfUseStyles.wrp, className) }>{ children }</div>;
};

export default TermsOfUse;
